import { EventBus } from "../../../eventbus";

export default {
  props: {
    parentId: String,
    label: String,
    type: String, //link, emitter or radio
    //only link and emitter
    icon: String,
    //only link
    to: String,
    //only emitter and radio
    emitterName: String,
    emitterData: Object,
    //extras
    color: String,
  },
  methods: {
    goTo(link, e) {
      e.preventDefault();

      this.$router.push(link);

      this.closeTopOptions();
    },
    emit(name, data, e) {
      if (this.type !== "radio") {
        e.preventDefault();
      }

      EventBus.$emit(name, data);

      this.closeTopOptions();
    },
    closeTopOptions() {
      EventBus.$emit(`${this.$parent.$options.name}-show`, {
        id: this.parentId,
        show: false,
      });
    },
  },
};
